import { useState, type ChangeEvent } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { api, formatApiError } from "@/lib/api";

export function EmailChangeDialog() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ new_email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/settings/email", form);
      toast.success(`Te mandamos un enlace a ${form.new_email}. El cambio se aplica al confirmarlo.`);
      setOpen(false); setForm({ new_email: "", password: "" });
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><button type="button" className="text-xs font-semibold text-[#1B2A4A] underline underline-offset-2" data-testid="settings-change-email-button">Cambiar correo</button></DialogTrigger>
      <DialogContent className="bg-white" data-testid="email-change-dialog">
        <DialogHeader>
          <DialogTitle>Cambiar correo</DialogTitle>
          <DialogDescription>Te mandaremos un enlace al correo nuevo y un aviso al actual. El enlace vence en 1 hora.</DialogDescription>
        </DialogHeader>
        <Input placeholder="Correo nuevo" type="email" value={form.new_email} onChange={(e: ChangeEvent<HTMLInputElement>) => setForm({ ...form, new_email: e.target.value })} className="h-11" data-testid="email-change-new-input" />
        <Input placeholder="Tu contraseña" type="password" value={form.password} onChange={(e: ChangeEvent<HTMLInputElement>) => setForm({ ...form, password: e.target.value })} className="h-11" data-testid="email-change-password-input" />
        <DialogFooter><Button onClick={submit} disabled={busy || !form.new_email || !form.password} className="bg-[#1B2A4A] text-white hover:bg-[#2A3D63]" data-testid="email-change-submit">Enviar enlace</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
